import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDollarSign, faStar, faPlus } from "@fortawesome/free-solid-svg-icons";

export default function NotificationEpkCard({ epkInfo, imgIsSelected }) {
  const { t } = useTranslation();
  const BANNER_IMG = `${process.env.REACT_APP_AWS_URL}/${epkInfo.banner_url}`;
  const pendingCount = epkInfo.requests?.filter(r => r.status === "pending").length || 0;

  const Stat = ({ icon, count }) => (
    <div className="tw-flex tw-flex-col tw-items-center tw-gap-0.5 tw-p-1">
      <FontAwesomeIcon
        icon={icon}
        className={`tw-text-sm ${imgIsSelected ? "tw-text-[#C084FC]" : "tw-text-white/30"}`}
      />
      <span className="tw-text-[10px] tw-font-bold tw-text-white/50">{count ?? 0}</span>
    </div>
  );

  return (
    <div className={`tw-flex tw-items-center tw-gap-3 tw-p-3 tw-rounded-xl tw-mb-2 tw-cursor-pointer tw-transition-all tw-border ${
      imgIsSelected
        ? "tw-bg-[#712CB0]/20 tw-border-[#712CB0]/40"
        : "tw-bg-white/5 tw-border-white/5 hover:tw-bg-white/10"
    }`}>
      <img
        className={`tw-rounded-lg tw-object-cover tw-flex-shrink-0 tw-transition-all ${
          imgIsSelected ? "tw-h-16 tw-w-24" : "tw-h-12 tw-w-16 tw-opacity-60"
        }`}
        src={BANNER_IMG}
        alt={epkInfo.title || ""}
      />
      <div className="tw-flex-1 tw-min-w-0">
        <p className={`tw-truncate tw-text-sm tw-font-medium tw-m-0 ${imgIsSelected ? "tw-text-white" : "tw-text-white/50"}`}>
          {epkInfo.title}
        </p>
        {pendingCount > 0 && (
          <span className="tw-mt-1 tw-inline-flex tw-items-center tw-gap-1 tw-rounded-full tw-bg-amber-900/40 tw-px-2 tw-py-0.5 tw-text-[10px] tw-font-semibold tw-text-amber-300">
            <span className="tw-h-1.5 tw-w-1.5 tw-rounded-full tw-bg-amber-400 tw-inline-block" />
            {pendingCount} {t("pending")}
          </span>
        )}
      </div>
      <div className="tw-flex tw-gap-1 tw-flex-shrink-0">
        <Stat icon={faStar} count={epkInfo.likes?.length} />
        <Stat icon={faDollarSign} count={epkInfo.wishes_to_buy?.length} />
        <Stat icon={faPlus} count={epkInfo.favourites?.length} />
      </div>
    </div>
  );
}
